import { useTranslation } from 'react-i18next'
import { FormControl } from 'baseui/form-control'
import SDDatePicker from '@/shared/components/SDComponents/SDDatePicker/SDDatePicker'
import { SIZE } from 'baseui/button'
import pickedDayAsIso from '@/shared/tools/pickedDayAsIso'

interface ByCreationDateProps {
  label: string
  onDateChangeHandler: (date: string) => void
}

const ByCreationDate = ({ label, onDateChangeHandler }: ByCreationDateProps) => {
  const { t } = useTranslation()

  return (
    <FormControl label={label}>
      <SDDatePicker
        size={SIZE.compact}
        formatString='dd/MM/yyyy'
        placeholder={t('dashboard:filters.date_placeholder')}
        onChange={({ date }: { date: unknown }) => {
          onDateChangeHandler(pickedDayAsIso(date))
        }}
      />
    </FormControl>
  )
}

export default ByCreationDate
